var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPensionPlanCautious = function SvgPensionPlanCautious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 813,
    height: 152,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pension-plan-cautious_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#320327",
    d: "M0 10C0 4.477 4.477 0 10 0h793c5.523 0 10 4.477 10 10v132c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.791,
    cy: 184.768,
    r: 50.233,
    fill: "#5B3552"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.233,
    cy: 172.209,
    r: 50.233,
    fill: "#FF2E5B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.488,
    cy: 147.094,
    r: 50.233,
    fill: "#5B3552"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.93,
    cy: 134.535,
    r: 50.233,
    fill: "#FF2E5B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.186,
    cy: 109.418,
    r: 50.233,
    fill: "#5B3552"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.628,
    cy: 96.859,
    r: 50.233,
    fill: "#FF2E5B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497.884,
    cy: 71.745,
    r: 50.233,
    fill: "#5B3552"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485.326,
    cy: 59.187,
    r: 50.233,
    fill: "#FF2E5B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 648.582,
    cy: 179.745,
    r: 50.233,
    fill: "#5B3552"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 636.024,
    cy: 167.187,
    r: 50.233,
    fill: "#FF2E5B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 648.582,
    cy: 34.071,
    r: 50.233,
    fill: "#5B3552"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 636.024,
    cy: 21.512,
    r: 50.233,
    fill: "#FF2E5B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 796.767,
    cy: 142.07,
    r: 50.233,
    fill: "#5B3552"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.209,
    cy: 129.512,
    r: 50.233,
    fill: "#FF2E5B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 796.767,
    cy: -3.604,
    r: 50.233,
    fill: "#5B3552"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.209,
    cy: -16.163,
    r: 50.233,
    fill: "#FF2E5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pension-plan-cautious_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 10C0 4.477 4.477 0 10 0h793c5.523 0 10 4.477 10 10v132c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10z"
  })))));
};
export { SvgPensionPlanCautious as ReactComponent };
export default __webpack_public_path__ + "images/pension-plan-cautious.svg";